// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/chunks/" + chunkId + "." + {"231":"db04bcf7","274":"49d58cb3","835":"681851da"}[chunkId] + ".js";
};